import { Typography } from '@mui/material';
import './GGCalender.scss'

interface CalenderProps{
    month?: string,
    year?: number,
    day?: number
    className?: string
}

const GGCalender = (props: CalenderProps) => {
    return(
        <div className={`calendar ${props.className}`}>
            <div className='ears-container'>
                <div className='ears'></div>
                <div className='ears'></div>
            </div>
            <div className='month-year'>
                <Typography className='month-text'>{props.month}</Typography>
                <Typography className='year-text'>{props.year}</Typography>
            </div>
            <hr className='horizontal-divider'></hr>
            <div className='due-date'>
                <Typography className='date-text'>{props.day}</Typography>
            </div>
        </div>
    )
};

export default GGCalender;